/* STRUGA Island Artifacts Gift — state controller + flow. Vanilla JS, no dependencies. */
/* STRUGA-GIFT-CANON v2026-07-02.4 — canonical; guarded by struga-island-gift-guard. Do not strip currency(fmtUsd)/soft-filter/[data-header-cart-count]. */
/* Linear 4-step flow (UX refactor 2026-07-02): catalogue+filter → assemble → delivery(scenario) → live summary.
   The sticky CTA always routes to the NEXT incomplete step, so the buyer never scrolls back up.
   v.2: "Go to checkout" goes STRAIGHT to /checkout after the cart write — no interstitial. */
(function () {
  'use strict';

  var root = document.getElementById('gift-root');
  if (!root) return;

  var DATA = { products: {}, isRu: false, rubRate: 78, budgetTiers: [15000, 30000] };
  try { DATA = JSON.parse(document.getElementById('gb-data').textContent); } catch (e) {}
  var PRODUCTS = DATA.products || {};
  var isRu = !!DATA.isRu;
  var RATE = DATA.rubRate || 78;
  var BT = (DATA.budgetTiers && DATA.budgetTiers.length === 2 && DATA.budgetTiers[0] < DATA.budgetTiers[1])
    ? DATA.budgetTiers : [15000, 30000];
  var LS = 'ia_gift_v8';

  var T = isRu ? {
    notSelected: 'не выбран', piece: ['изделие', 'изделия', 'изделий'],
    toRecipient: 'получателю', toSelf: 'себе', toBali: 'на Бали',
    assemble: 'Собрать подарок', checkout: 'Оформить подарок', adding: 'Оформляем…',
    errCart: 'Не удалось добавить в корзину. Попробуйте ещё раз.',
    errItems: 'Сначала выберите хотя бы одно изделие.',
    errDelivery: 'Заполните имя и контакт для самовывоза на Бали.',
    errSize: 'Выберите размер у выделенного изделия, чтобы продолжить.',
    needScenario: 'Сначала выберите, как передать подарок.',
    cleared: 'Подарок очищен.', clearAll: 'Начать заново', clearConfirm: 'Очистить выбранный подарок?',
    size: 'Размер', engraving: 'Гравировка', engravingPh: 'Текст гравировки (до 20 символов)',
    remove: 'Убрать', pickSize: 'Выберите размер', sizeMissing: 'размер не выбран',
    whereTo: 'Куда передать?',
    sumPieces: 'Изделие', sumScenario: 'Сценарий', sumOccasion: 'Повод',
    sumPack: 'Упаковка', sumTime: 'Срок изготовления', sumDelivery: 'Передача', sumTotal: 'Итого',
    boxIncluded: 'фирменная коробка', days: '2–4 недели', dash: '—',
    from: 'от', upTo: 'до',
    scn: { recipient: 'Отправить получателю', self: 'Заказать себе', bali_pickup: 'Самовывоз на Бали' },
    occ: { birthday: 'День рождения', anniversary: 'Годовщина', self: 'Для себя', no_reason: 'Без повода', other: 'Другое' }
  } : {
    notSelected: 'not selected', piece: ['piece', 'pieces', 'pieces'],
    toRecipient: 'to recipient', toSelf: 'for myself', toBali: 'Bali pickup',
    assemble: 'Assemble the gift', checkout: 'Check out the gift', adding: 'Opening checkout…',
    errCart: 'Could not add to cart. Please try again.',
    errItems: 'Choose at least one piece first.',
    errDelivery: 'Enter a name and contact for Bali pickup.',
    errSize: 'Choose a size for the highlighted piece to continue.',
    needScenario: 'First choose how to give the gift.',
    cleared: 'Gift cleared.', clearAll: 'Start over', clearConfirm: 'Clear your gift selection?',
    size: 'Size', engraving: 'Engraving', engravingPh: 'Engraving text (up to 20 chars)',
    remove: 'Remove', pickSize: 'Choose a size', sizeMissing: 'size not selected',
    whereTo: 'Where to send?',
    sumPieces: 'Piece', sumScenario: 'Scenario', sumOccasion: 'Occasion',
    sumPack: 'Packaging', sumTime: 'Production time', sumDelivery: 'Delivery', sumTotal: 'Total',
    boxIncluded: 'signature box', days: '2–4 weeks', dash: '—',
    from: 'from', upTo: 'up to',
    scn: { recipient: 'Send to recipient', self: 'Order for myself', bali_pickup: 'Bali pickup' },
    occ: { birthday: 'Birthday', anniversary: 'Anniversary', self: 'For myself', no_reason: 'No occasion', other: 'Other' }
  };

  /* ---------- state ---------- */
  /* one-time migration: ia_gift_v7 (quiz-era) → ia_gift_v8 (linear flow).
     Carries items/scenario/occasion/delivery; folds the old per-scenario comment
     into the single comment; drops quiz answers and the never-shipped card fields. */
  try {
    if (!localStorage.getItem(LS)) {
      var old = JSON.parse(localStorage.getItem('ia_gift_v7') || 'null');
      if (old && typeof old === 'object') {
        var od = old.delivery || {};
        var scnComment = od.rec_comment || od.self_comment || od.bali_comment || '';
        delete od.rec_comment; delete od.self_comment; delete od.bali_comment;
        var migrated = {
          scenario: old.scenario || null,
          items: old.items || {},
          occasion: old.occasion || null,
          comment: old.comment ? (scnComment ? old.comment + ' · ' + scnComment : old.comment) : scnComment,
          delivery: od
        };
        localStorage.setItem(LS, JSON.stringify(migrated));
      }
    }
    localStorage.removeItem('ia_gift_v7');
  } catch (e) {}

  var S = { scenario: null, items: {}, occasion: null, comment: '', delivery: {} };
  try {
    var saved = JSON.parse(localStorage.getItem(LS));
    if (saved && typeof saved === 'object') {
      Object.keys(S).forEach(function (k) { if (saved[k] != null) S[k] = saved[k]; });
    }
  } catch (e) {}
  Object.keys(S.items).forEach(function (h) { if (!PRODUCTS[h]) delete S.items[h]; });
  function save() { try { localStorage.setItem(LS, JSON.stringify(S)); } catch (e) {} }

  /* catalogue filter is ephemeral discovery — two independent axes, never persisted */
  var F = { budget: null, noSize: false };

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function show(el, on) { if (el) el.hidden = !on; }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/["\\\]]/g, '\\$&'); }
  // parse a Shopify money label ("7 500 ₽", "$1,270") down to a number
  function priceFromLabel(label) {
    return parseFloat(String(label == null ? '' : label).replace(/[^\d.]/g, '')) || 0;
  }
  /* ---------- currency (mirror of struga-com-price-canon: USD from IDR, then buyer currency via Bucks) ---------- */
  // Доллар: на .ru — из рупий единой розницы (17 822,85, как struga-rub-v4); на .com с 23.10.2026 — из рупий
  // цены «всё включено» по курсу каталога 17 823, как struga-com-price-canon.
  var IDR_PER_USD = isRu ? 17822.85 : 17823, RUB_PER_USD = 78, RUB_STEP = 50;
  var CUR_SYMBOL = { USD: '$', EUR: '€', GBP: '£', JPY: '¥', CNY: 'CN¥', CHF: 'CHF ', AUD: 'A$',
    CAD: 'C$', SGD: 'S$', HKD: 'HK$', TWD: 'NT$', KRW: '₩', AED: 'AED ', THB: '฿', IDR: 'Rp ' };
  function grp(n, sep) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function niceRound(a) {
    if (!(a > 0)) return 0;
    if (a < 100) return Math.round(a);
    if (a < 1000) return Math.round(a / 10) * 10;
    if (a < 10000) return Math.round(a / 50) * 50;
    if (a < 100000) return Math.round(a / 100) * 100;
    if (a < 1000000) return Math.round(a / 500) * 500;
    return Math.round(a / 1000) * 1000;
  }
  function bucksRates() { try { return window.bucksCC.Currency.rates; } catch (e) { return null; } }
  // the currency the buyer actually sees (Bucks): live converted element → canon's decision → USD.
  // .com has no rubles (Dmitry 23.10.2026: «на .com рубли убираем»). Bucks storage is no longer read
  // here: returning visitors from Russia keep buckscc_auto_currency=RUB (since 30.09, no expiry), a
  // currency Bucks no longer shows; the canon (struga-com-price-canon) validates stored currencies
  // against Bucks' allowed list and exposes the result as window.__strugaCanonCurrency().
  function activeCur() {
    if (isRu) return 'RUB';
    // ground truth = what Bucks is actually showing (attr survives even after canon hides the el)
    try { var el = document.querySelector('[bucks-currency]'); if (el) { var c = String(el.getAttribute('bucks-currency') || '').toUpperCase(); if (c && c !== 'RUB') return c; } } catch (e) {}
    try { if (typeof window.__strugaCanonCurrency === 'function') { var k = window.__strugaCanonCurrency(); if (k && k !== 'RUB') return k; } } catch (e) {}
    return 'USD';
  }
  function usdOf(idr) { var u = Math.round((idr || 0) / IDR_PER_USD); return (u < 1 && idr > 0) ? 1 : u; }
  // format a USD amount into the buyer's current currency, deterministically (no Bucks text rewrite)
  function fmtUsd(usd) {
    usd = Math.round(usd || 0);
    var cur = activeCur();
    if (cur === 'RUB') return grp(Math.round(usd * RUB_PER_USD / RUB_STEP) * RUB_STEP, ' ') + ' ₽';
    if (cur === 'USD') return '$' + grp(usd, ',');
    if (cur === 'IDR') return 'Rp ' + grp(Math.round(usd * IDR_PER_USD), '.');
    var R = bucksRates();
    if (R && R[cur] > 0) { return (CUR_SYMBOL[cur] || (cur + ' ')) + grp(niceRound(usd / R[cur]), ','); }
    return '$' + grp(usd, ',');
  }
  // IDR price of a selected item (legacy state may lack .idr → derive from product/variant)
  function itemIdr(h) {
    var s = S.items[h], p = PRODUCTS[h];
    if (!s || !p) return 0;
    if (s.idr != null) return s.idr;
    if (s.variantIdx != null && p.variants[s.variantIdx]) return p.variants[s.variantIdx].price;
    return p.priceMin;
  }
  // total label in the active currency (RU keeps the server ₽ labels; others compute live)
  function totalLabel() {
    if (isRu) {
      var n = Object.keys(S.items).reduce(function (sum, h) {
        var s = S.items[h];
        if (!s || s.variantIdx == null || !s.priceLabel) return sum;
        return sum + priceFromLabel(s.priceLabel);
      }, 0);
      return Math.round(n).toLocaleString('ru-RU') + ' ₽';
    }
    var usd = Object.keys(S.items).reduce(function (sum, h) {
      var s = S.items[h];
      if (!s || s.variantIdx == null) return sum;
      return sum + usdOf(itemIdr(h));
    }, 0);
    return fmtUsd(usd);
  }
  function plural(n, forms) {
    var a = Math.abs(n) % 100, b = a % 10;
    if (a > 10 && a < 20) return forms[2];
    if (b > 1 && b < 5) return forms[1];
    if (b === 1) return forms[0];
    return forms[2];
  }
  function jump(id) { var el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cardRub(card) { return (parseFloat(card.dataset.usd) || 0) * RATE; }
  function budgetBucket(rub) { return rub < BT[0] ? 'b1' : rub < BT[1] ? 'b2' : 'b3'; }
  function itemsCount() { return Object.keys(S.items).length; }

  /* transient toast + flash highlight, so guidance is never silent */
  var _toastEl = null, _toastT = null;
  function toast(msg) {
    if (!_toastEl) {
      _toastEl = document.createElement('div');
      _toastEl.className = 'gb-toast';
      _toastEl.setAttribute('role', 'status');
      _toastEl.setAttribute('aria-live', 'polite');
      root.appendChild(_toastEl);
    }
    _toastEl.textContent = msg;
    // force reflow so re-triggering restarts the transition
    void _toastEl.offsetWidth;
    _toastEl.classList.add('is-show');
    clearTimeout(_toastT);
    _toastT = setTimeout(function () { _toastEl.classList.remove('is-show'); }, 3400);
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('gb-flash'); void el.offsetWidth; el.classList.add('gb-flash');
  }

  // update every cart-count element the theme might use (the visible header badge
  // is [data-header-cart-count]; the old code only touched [data-cart-count]).
  function updateCartCount(n) {
    $all('[data-cart-count],[data-header-cart-count],.cart-count').forEach(function (el) { el.textContent = n; });
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { item_count: n } })); } catch (e) {}
  }

  // handles of pieces still missing a required size
  function unsizedHandles() {
    return Object.keys(S.items).filter(function (h) {
      var s = S.items[h], p = PRODUCTS[h];
      return p && p.variantCount > 1 && (!s || s.variantIdx == null);
    });
  }
  function hasUnsizedItem() { return unsizedHandles().length > 0; }
  // scroll to + flash the first unsized piece, and toast why checkout paused
  function guideToUnsized() {
    jump('gb-personalization');
    toast(T.errSize);
    var first = unsizedHandles()[0];
    if (!first) return;
    setTimeout(function () {
      var row = $('.gb-item[data-h="' + cssEsc(first) + '"]');
      if (row) { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); flash(row); }
    }, 360);
  }
  // scroll to + flash the scenario chips (step 3), and toast why checkout paused
  function guideToScenario() {
    var el = document.getElementById('gb-delivery');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    flash($('#gb-scn-grid'));
    toast(T.needScenario);
  }

  /* ---------- catalogue filter (two axes: budget single-select + size-free toggle) ---------- */
  // soft filter: surfaces matches (sorted first, full strength) but never HIDES the
  // rest — the small catalogue always stays visible, so nothing reads as "broken / 1–2 items".
  function applyFilter() {
    var cards = $all('.gb-card');
    var active = !!(F.budget || F.noSize);
    var matched = !active ? [] : cards.filter(function (c) {
      if (F.budget && budgetBucket(cardRub(c)) !== F.budget) return false;
      if (F.noSize && c.dataset.needsSize === 'true') return false;
      return true;
    });
    var inSet = {};
    matched.forEach(function (c, i) { inSet[c.dataset.handle] = i + 1; });
    var soft = active && matched.length > 0; // don't dim everything when nothing matches
    cards.forEach(function (c) {
      c.hidden = false;
      var rank = inSet[c.dataset.handle];
      c.classList.toggle('gb-dim', soft && !rank);
      c.style.order = soft ? (rank || 999) : '';
    });
    // chip states + match counter on the active chips
    $all('.gb-fchip').forEach(function (b) {
      var on = b.dataset.f === 'budget'
        ? (F.budget || 'all') === b.dataset.v
        : F.noSize;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var cnt = $('.gb-fchip-count', b);
      if (cnt) cnt.textContent = (on && soft && b.dataset.v !== 'all') ? ' · ' + matched.length : '';
    });
  }
  function setFilter(kind, v) {
    if (kind === 'budget') {
      if (v === 'all') { F.budget = null; F.noSize = false; } // «Все» = full reset
      else F.budget = (F.budget === v) ? null : v;
    } else if (kind === 'nosize') {
      F.noSize = !F.noSize;
    }
    applyFilter();
  }
  function resetFilter() { F.budget = null; F.noSize = false; applyFilter(); }

  /* ---------- scenario (lives inside step 3 · delivery) ---------- */
  function selectScenario(scn) {
    S.scenario = scn; save();
    $all('.gb-scn-card').forEach(function (c) {
      var on = c.dataset.scenario === scn;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    renderDelivery();
    renderSticky();
    renderSummaryLive();
  }

  /* ---------- delivery ---------- */
  function renderDelivery() {
    var hasItems = itemsCount() > 0;
    show($('#gb-deliv-empty'), !hasItems);
    show($('#gb-deliv-body'), hasItems);
    $all('.gb-deliv-group').forEach(function (g) {
      show(g, hasItems && g.dataset.deliveryFor === S.scenario);
    });
  }

  /* ---------- waiting steps: while nothing is chosen, steps 2–4 stay compact ---------- */
  function syncWaiting() {
    var waiting = itemsCount() === 0;
    ['gb-personalization', 'gb-delivery', 'gb-summary'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.toggle('gb-wait', waiting);
    });
  }

  /* ---------- product selection ---------- */
  function toggleItem(handle) {
    var p = PRODUCTS[handle];
    if (!p) return;
    if (S.items[handle]) {
      delete S.items[handle];
    } else if ((p.variantCount || (p.variants || []).length) > 1) {
      // size_required — buyer must pick a size, no silent variants[0]
      S.items[handle] = { vid: null, variantIdx: null, idr: null, priceLabel: '', engrave: '' };
    } else {
      // single variant (no_size / one_size) — use the only variant
      var v = (p.variants && p.variants[0]) || { id: 0, priceLabel: p.priceMinLabel };
      S.items[handle] = { vid: v.id, variantIdx: 0, idr: (v.price != null ? v.price : p.priceMin), priceLabel: v.priceLabel || p.priceMinLabel, engrave: '' };
    }
    save();
    syncCardStates();
    renderItems();
    renderDelivery();
    syncWaiting();
    renderSticky();
    renderSummaryLive();
  }
  function syncCardStates() {
    $all('.gb-card').forEach(function (card) {
      card.classList.toggle('is-selected', !!S.items[card.dataset.handle]);
    });
  }

  /* ---------- step 2: selected items ---------- */
  function renderItems() {
    var box = $('#gb-items');
    var handles = Object.keys(S.items);
    show($('#gb-pers-empty'), handles.length === 0);
    show($('#gb-pers-body'), handles.length > 0);
    if (!handles.length) { box.innerHTML = ''; return; }

    box.innerHTML = handles.map(function (h) {
      var s = S.items[h], p = PRODUCTS[h];
      if (!p) return '';
      var multi = (p.variantCount || (p.variants || []).length) > 1;
      var unsized = multi && s.variantIdx == null;
      var html = '<div class="gb-item' + (unsized ? ' gb-item--unsized' : '') + '" data-h="' + esc(h) + '">';
      html += '<div class="gb-item-top">';
      if (p.img) html += '<img src="' + esc(p.img) + '" alt="">';
      html += '<div class="gb-item-info"><div class="gb-item-name">' + esc(p.title) + '</div>';
      var priceHtml = unsized
        ? '<span class="gb-item-price-hint">' + esc(T.pickSize) + '</span>'
        : esc(isRu ? (s.priceLabel || p.priceMinLabel || '') : fmtUsd(usdOf(itemIdr(h))));
      html += '<div class="gb-item-price" data-price-h="' + esc(h) + '">' + priceHtml + '</div></div>';
      html += '<button type="button" class="gb-item-remove" data-remove-h="' + esc(h) + '">' + T.remove + '</button>';
      html += '</div>';

      if (multi) {
        html += '<div class="gb-item-opts"><p class="gb-opt-name">' + esc(p.optionName || T.size) + '</p><div class="gb-var-btns">';
        p.variants.forEach(function (v, i) {
          html += '<button type="button" class="gb-var-btn' + (i === s.variantIdx ? ' is-active' : '') + '"'
            + (v.available ? '' : ' disabled') + ' data-var-h="' + esc(h) + '" data-var-i="' + i + '">'
            + esc(v.title) + ' — ' + esc(isRu ? (v.priceLabel || '') : fmtUsd(usdOf(v.price))) + '</button>';
        });
        html += '</div></div>';
      }

      html += '<div class="gb-item-engrave"><label><input type="checkbox" data-eng-h="' + esc(h) + '"'
        + (s.engrave ? ' checked' : '') + '> ' + T.engraving + '</label>';
      html += '<input type="text" class="gb-input" data-engtext-h="' + esc(h) + '" maxlength="20" placeholder="'
        + esc(T.engravingPh) + '" value="' + esc(s.engrave || '') + '"' + (s.engrave ? '' : ' hidden') + '>';
      html += '</div></div>';
      return html;
    }).join('');
  }
  function pickVariant(h, i) {
    var p = PRODUCTS[h], s = S.items[h];
    if (!p || !s) return;
    var v = p.variants[i];
    if (!v || !v.available) return;
    s.vid = v.id; s.variantIdx = i; s.idr = v.price; s.priceLabel = v.priceLabel || p.priceMinLabel; save();
    var row = $('.gb-item[data-h="' + cssEsc(h) + '"]');
    if (row) {
      row.classList.remove('gb-item--unsized');
      var pr = $('[data-price-h="' + cssEsc(h) + '"]', row);
      if (pr) pr.textContent = isRu ? s.priceLabel : fmtUsd(usdOf(v.price));
      $all('.gb-var-btn', row).forEach(function (b, bi) { b.classList.toggle('is-active', bi === i); });
    }
    renderSticky();
    renderSummaryLive();
  }

  /* ---------- step 2: occasion chips ---------- */
  function setOccasion(v) {
    S.occasion = (S.occasion === v) ? null : v;
    save();
    $all('.gb-opt[data-g="occasion"]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.v === S.occasion);
    });
    renderSummaryLive();
  }

  /* ---------- step 4: live summary ---------- */
  var checkoutLabel = (($('#gb-checkout') || {}).textContent || '').trim();
  function deliveryText() {
    var d = S.delivery || {};
    if (S.scenario === 'recipient') return [T.scn.recipient, d.rec_date].filter(Boolean).join(' · ');
    if (S.scenario === 'self') return [T.scn.self, d.self_date].filter(Boolean).join(' · ');
    if (S.scenario === 'bali_pickup') return [T.scn.bali_pickup, d.bali_date].filter(Boolean).join(' · ');
    return T.dash;
  }
  // the summary is LIVE: re-rendered on every state change, so scrolling to step 4
  // always shows the real gift.
  function renderSummaryLive() {
    var handles = Object.keys(S.items);
    var body = $('#gb-summary-body');
    if (!handles.length) {
      body.innerHTML = '<p class="gb-empty">' + (isRu
        ? 'Соберите подарок выше — здесь появится итог.'
        : 'Assemble the gift above — the summary will appear here.') + '</p>';
      show($('#gb-summary-actions'), false);
      show($('#gb-summary-kicker'), false);
      return;
    }
    var names = handles.map(function (h) {
      var p = PRODUCTS[h];
      var title = p ? p.title : h;
      if (p && p.variantCount > 1 && S.items[h].variantIdx == null) {
        title += ' (' + T.sizeMissing + ')';
      }
      return title;
    }).join(', ');
    var rows = [
      [T.sumPieces, names],
      [T.sumScenario, S.scenario ? T.scn[S.scenario] : T.dash],
      [T.sumOccasion, S.occasion ? T.occ[S.occasion] : T.dash],
      [T.sumPack, T.boxIncluded],
      [T.sumTime, T.days],
      [T.sumDelivery, deliveryText()],
      [T.sumTotal, totalLabel()]
    ];
    var unsized = hasUnsizedItem();
    var html = '<dl>' + rows.map(function (r) {
      return '<div class="gb-summary-row"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>';
    }).join('') + '</dl>';
    if (unsized) {
      html += '<p class="gb-summary-warn">' + esc(T.errSize) + '</p>';
    }
    body.innerHTML = html;
    // never silently disable checkout — a disabled button reads as a dead button.
    // if a size or scenario is missing, the click handler guides the buyer instead.
    var checkoutBtn = $('#gb-checkout');
    if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.textContent = checkoutLabel; checkoutBtn.classList.toggle('gb-btn--warn', unsized || !S.scenario); }
    show($('#gb-summary-body'), true);
    show($('#gb-summary-actions'), true);
    show($('#gb-summary-kicker'), true);
  }
  // debounced summary refresh for text inputs (delivery dates feed the summary rows)
  var _sumT = null;
  function renderSummaryDebounced() {
    clearTimeout(_sumT);
    _sumT = setTimeout(renderSummaryLive, 200);
  }

  /* ---------- sticky bar: always routes to the NEXT incomplete step ---------- */
  function nextStep() {
    if (!itemsCount()) return 'items';
    if (hasUnsizedItem()) return 'size';
    if (!S.scenario) return 'scenario';
    return 'summary';
  }
  function renderSticky() {
    var bar = $('#gb-sticky');
    show(bar, true);
    var n = itemsCount();
    var stateEl = $('#gb-sticky-state'), totalEl = $('#gb-sticky-total'), cta = $('#gb-sticky-cta'), clr = $('#gb-sticky-clear');
    if (clr) clr.hidden = !n;
    if (!n) {
      stateEl.textContent = T.notSelected;
      totalEl.textContent = '';
      cta.textContent = T.assemble;
      return;
    }
    var parts = [n + ' ' + plural(n, T.piece)];
    if (S.scenario) parts.push(S.scenario === 'recipient' ? T.toRecipient : S.scenario === 'self' ? T.toSelf : T.toBali);
    stateEl.textContent = parts.join(' · ');
    totalEl.textContent = totalLabel();
    var step = nextStep();
    cta.textContent = step === 'size' ? T.pickSize : step === 'scenario' ? T.whereTo : T.checkout;
  }
  function stickyRoute() {
    var step = nextStep();
    if (step === 'items') { jump('gb-grid'); return; }
    if (step === 'size') { guideToUnsized(); return; }
    if (step === 'scenario') { guideToScenario(); return; }
    renderSummaryLive(); jump('gb-summary');
  }

  /* ---------- validation (only Bali pickup needs contact details) ---------- */
  function validateDelivery() {
    var d = S.delivery || {}, need = [];
    if (S.scenario === 'bali_pickup') need = ['bali_name', 'bali_contact'];
    var missing = need.filter(function (k) { return !d[k] || !d[k].trim(); });
    var firstEl = null;
    $all('.gb-deliv-group [data-d]').forEach(function (inp) {
      var bad = missing.indexOf(inp.dataset.d) !== -1;
      inp.classList.toggle('gb-input--err', bad);
      if (bad && !firstEl) firstEl = inp;
    });
    if (firstEl) { firstEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); flash(firstEl); }
    return missing.length === 0;
  }

  /* ---------- reset ---------- */
  function resetAll() {
    S = { scenario: null, items: {}, occasion: null, comment: '', delivery: {} };
    try { localStorage.removeItem(LS); } catch (e) {}
    $all('.gb-scn-card').forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
    $all('.gb-opt[data-g]').forEach(function (b) { b.classList.remove('is-active'); });
    var cm = $('#gb-comment'); if (cm) cm.value = '';
    $all('.gb-deliv-group [data-d]').forEach(function (inp) { inp.value = ''; inp.classList.remove('gb-input--err'); });
    var checkoutBtn = $('#gb-checkout');
    if (checkoutBtn) { checkoutBtn.disabled = false; checkoutBtn.classList.remove('gb-btn--warn'); }
    show($('#gb-summary-kicker'), false);
    resetFilter();
    syncCardStates();
    renderDelivery();
    renderItems();
    syncWaiting();
    renderSticky();
    renderSummaryLive();
  }

  /* ---------- add to cart ---------- */
  function addToCart() {
    var handles = Object.keys(S.items);
    if (!handles.length) { toast(T.errItems); jump('gb-grid'); return; }
    // block silent add-to-cart while a size_required piece has no size chosen
    if (hasUnsizedItem()) { guideToUnsized(); return; }
    // the delivery scenario is REQUIRED — an order without one is un-fulfillable
    if (!S.scenario) { guideToScenario(); return; }
    if (!validateDelivery()) { toast(T.errDelivery); return; }

    var btn = $('#gb-checkout');
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = T.adding;

    var lineItems = handles.map(function (h) {
      var s = S.items[h];
      var props = { 'Island Artifacts': 'Yes', '_gift_flow': 'island_artifacts_gift' };
      if (S.occasion) props['Occasion'] = T.occ[S.occasion];
      if (s.engrave && s.engrave.trim()) props['Engraving'] = s.engrave.trim();
      if (S.comment.trim()) props['Note'] = S.comment.trim();
      return { id: parseInt(s.vid, 10), quantity: 1, properties: props };
    });

    var d = S.delivery || {};
    // always send the FULL attribute set — '' clears a key on Shopify, so re-assembling
    // the gift under another scenario never leaves stale attributes on the order
    var attrs = {
      'Gift scenario': T.scn[S.scenario],
      // the single step-2 comment feeds the order-wide attribute too (fulfilment reads it here)
      'Gift comment': S.comment.trim(),
      'Desired date': '', 'Bali pickup name': '', 'Bali pickup contact': '', 'Bali pickup date': ''
    };
    if (S.scenario === 'recipient') {
      attrs['Desired date'] = d.rec_date || '';
    } else if (S.scenario === 'self') {
      attrs['Desired date'] = d.self_date || '';
    } else if (S.scenario === 'bali_pickup') {
      attrs['Bali pickup name'] = d.bali_name || '';
      attrs['Bali pickup contact'] = d.bali_contact || '';
      attrs['Bali pickup date'] = d.bali_date || '';
    }

    var jpost = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    };

    var done = false;
    // 1. drop stale gift line items so re-assembly replaces instead of stacking
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        var stale = (cart.items || []).filter(function (it) {
          return it.properties && it.properties['Island Artifacts'] === 'Yes';
        }).map(function (it) { return it.key; });
        if (!stale.length) return null;
        var updates = {};
        stale.forEach(function (k) { updates[k] = 0; });
        return jpost('/cart/update.js', { updates: updates });
      })
      // 2. add the current gift
      .then(function () { return jpost('/cart/add.js', { items: lineItems }); })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      // 3. write order-wide gift attributes
      .then(function () { return jpost('/cart/update.js', { attributes: attrs }); })
      .then(function () {
        done = true;
        // straight to checkout — the button promises "go to checkout", so it goes there.
        // No interstitial, no cart detour. localStorage is cleared so a LATER visit starts
        // clean, but the in-memory state stays: pressing Back from checkout restores the
        // assembled gift for editing (re-checkout replaces the gift lines, never stacks).
        try { localStorage.removeItem(LS); } catch (e) {}
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = origText;
        toast(T.errCart);
      })
      // safety net: never leave the button stuck on the busy label
      .then(function () {
        if (!done && btn.textContent === T.adding) { btn.disabled = false; btn.textContent = origText; }
      });
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('.gb-fchip'))) { setFilter(el.dataset.f, el.dataset.v); return; }
    if ((el = t.closest('.gb-scn-card'))) { selectScenario(el.dataset.scenario); return; }
    if ((el = t.closest('.gb-card-choose'))) { toggleItem(el.dataset.handle); return; }
    if ((el = t.closest('.gb-item-remove'))) { toggleItem(el.dataset.removeH); return; }
    if ((el = t.closest('.gb-var-btn'))) { pickVariant(el.dataset.varH, parseInt(el.dataset.varI, 10)); return; }
    if ((el = t.closest('.gb-opt[data-g="occasion"]'))) { setOccasion(el.dataset.v); return; }
    if (t.closest('#gb-sticky-clear')) {
      if (window.confirm(T.clearConfirm)) { resetAll(); toast(T.cleared); jump('gb-grid'); }
      return;
    }
    if (t.closest('#gb-checkout')) { addToCart(); return; }
    if (t.closest('#gb-sticky-cta')) { stickyRoute(); return; }
    if ((el = t.closest('[data-jump]'))) { jump(el.dataset.jump); return; }
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'gb-comment') { S.comment = t.value; save(); return; }
    if (t.dataset && t.dataset.d != null) {
      S.delivery[t.dataset.d] = t.value; save();
      t.classList.remove('gb-input--err');
      renderSummaryDebounced();
      return;
    }
    if (t.dataset && t.dataset.engtextH != null) {
      var h = t.dataset.engtextH;
      if (S.items[h]) { S.items[h].engrave = t.value; save(); }
      return;
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset && t.dataset.engH != null) {
      var h = t.dataset.engH;
      var box = t.closest('.gb-item-engrave');
      var txt = box ? $('[data-engtext-h]', box) : null;
      if (txt) {
        txt.hidden = !t.checked;
        if (!t.checked) { txt.value = ''; if (S.items[h]) { S.items[h].engrave = ''; save(); } }
      }
    }
  });

  /* ---------- inject "start over" control into the sticky bar (no markup change needed) ---------- */
  (function injectClear() {
    var right = $('.gb-sticky-right');
    if (!right || $('#gb-sticky-clear')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'gb-sticky-clear';
    btn.className = 'gb-link-btn gb-sticky-clear';
    btn.textContent = T.clearAll;
    btn.hidden = true;
    right.insertBefore(btn, right.firstChild);
  })();

  /* ---------- live currency rendering (grid prices + budget chips), reuse Bucks ---------- */
  function productVaries(h) {
    var p = PRODUCTS[h]; if (!p || !p.variants || !p.variants.length) return false;
    var first = p.variants[0].price;
    for (var i = 1; i < p.variants.length; i++) { if (p.variants[i].price !== first) return true; }
    return false;
  }
  function reformatGrid() {
    if (isRu) return; // RU grid is server-rendered ₽ (struga-rub-inline) — leave it
    $all('.gb-card').forEach(function (card) {
      var pe = $('.gb-card-price', card); if (!pe) return;
      var usd = Math.round(parseFloat(card.dataset.usd) || 0);
      var pre = productVaries(card.dataset.handle) ? (T.from + ' ') : '';
      pe.textContent = pre + fmtUsd(usd);
    });
  }
  function reformatBudget() {
    if (isRu) return; // RU labels are server ₽
    var t1 = Math.round(BT[0] / RUB_PER_USD), t2 = Math.round(BT[1] / RUB_PER_USD);
    var l1 = $('.gb-fchip[data-v="b1"] .gb-fchip-label'),
        l2 = $('.gb-fchip[data-v="b2"] .gb-fchip-label'),
        l3 = $('.gb-fchip[data-v="b3"] .gb-fchip-label');
    if (l1) l1.textContent = T.upTo + ' ' + fmtUsd(t1);
    if (l2) l2.textContent = fmtUsd(t1) + '–' + fmtUsd(t2);
    if (l3) l3.textContent = T.from + ' ' + fmtUsd(t2);
  }
  function reformatAll() {
    reformatGrid(); reformatBudget();
    renderItems(); renderSticky();
    renderSummaryLive();
  }
  // when the buyer switches currency, Bucks calls reConvert/rerender → re-render gift prices too
  function hookBucks() {
    try {
      var B = window.bucksCC;
      ['reConvert', 'rerender'].forEach(function (m) {
        if (B && typeof B[m] === 'function' && !B[m].__gb) {
          var o = B[m];
          B[m] = function () { var r = o.apply(this, arguments); try { setTimeout(reformatAll, 0); } catch (e) {} return r; };
          B[m].__gb = true;
        }
      });
    } catch (e) {}
  }
  // Robust startup: poll until Bucks rates are loaded, re-render whenever the active
  // currency settles or changes (covers rates loading late + auto-geo switch), and hook
  // reConvert/rerender so manual currency switches re-render gift prices too. Belt + suspenders
  // so the buyer currency ALWAYS reaches every price, regardless of Bucks load timing.
  var _lastCur = null;
  // re-render every price surface whenever the active currency settles or changes
  function applyCurrency() {
    if (!bucksRates()) return;          // wait until Bucks rates are loaded
    var c = activeCur();
    if (c === _lastCur) return;
    _lastCur = c; hookBucks(); reformatAll();
  }
  function initCurrency() {
    if (isRu) return;                   // RU is always ₽ (server) — JS leaves prices alone
    reformatGrid(); reformatBudget();   // immediate paint (server $ fallback) before Bucks is ready
    // 1) event-driven: observe the currency probe — catches Bucks finishing late, auto-geo, and
    //    manual switches, with NO fixed time window (this is what makes it un-break-able).
    try {
      var probe = document.getElementById('gb-cur-probe');
      if (probe && window.MutationObserver) {
        new MutationObserver(function () { setTimeout(applyCurrency, 30); })
          .observe(probe, { subtree: true, childList: true, attributes: true, attributeFilter: ['bucks-currency'] });
      }
    } catch (e) {}
    // 2) poll as a safety net until rates+currency are ready (covers no-observer / slow Bucks)
    var n = 0; (function tick() { applyCurrency(); hookBucks(); if (++n < 60) setTimeout(tick, 400); })();
  }

  /* ---------- restore UI from saved state ---------- */
  function restore() {
    // if no piece was actually being assembled, start clean (no stuck scenario / fields the buyer didn't pick)
    if (!Object.keys(S.items).length) {
      S.scenario = null; S.occasion = null; S.comment = ''; S.delivery = {};
    }
    save();

    if (S.scenario) selectScenario(S.scenario); else renderDelivery();
    if (S.occasion) $all('.gb-opt[data-g="occasion"]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.v === S.occasion);
    });
    var cm = $('#gb-comment'); if (cm && S.comment) cm.value = S.comment;
    $all('.gb-deliv-group [data-d]').forEach(function (inp) {
      if (S.delivery[inp.dataset.d]) inp.value = S.delivery[inp.dataset.d];
    });
    applyFilter();
    syncCardStates();
    renderItems();
    syncWaiting();
    renderSticky();
    renderSummaryLive();
    initCurrency();
  }

  restore();
})();
